var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activity && _vm.activity.id)?_c(_vm.tag,{tag:"component",attrs:{"disabled":_vm.disabled,"block":_vm.block,"theme":_vm.theme,"loading":_vm.pending},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v("Перейти к заданию")]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }